import { GET_DC } from '../../types';

export const getDC = (data) => {
    return { type: GET_DC, data }
}
